import { render, staticRenderFns } from "./externalGdpr.vue?vue&type=template&id=0f470ae2&scoped=true&lang=pug&"
import script from "./externalGdpr.vue?vue&type=script&lang=js&"
export * from "./externalGdpr.vue?vue&type=script&lang=js&"
import style0 from "./externalGdpr.vue?vue&type=style&index=0&id=0f470ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f470ae2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f470ae2')) {
      api.createRecord('0f470ae2', component.options)
    } else {
      api.reload('0f470ae2', component.options)
    }
    module.hot.accept("./externalGdpr.vue?vue&type=template&id=0f470ae2&scoped=true&lang=pug&", function () {
      api.rerender('0f470ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/externalGdpr/externalGdpr.vue"
export default component.exports